import React, { ReactNode } from "react";
import { useTranslation } from 'react-i18next';

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  onSave: () => void;
  isSaving: boolean;
  error?: string | null;
  saveButtonLabel?: string;
}

const EditModal: React.FC<EditModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onSave,
  isSaving,
  error,
  saveButtonLabel = "Save Changes",
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              aria-label={t('editModal.close')}
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {error && (
              <div
                className="alert alert-danger alert-dismissible fade show mb-3"
                role="alert"
              >
                <strong>{t('editModal.saveError')}</strong>{" "}
                <span style={{ whiteSpace: "pre-line" }}>{error}</span>
                {/* <button
                  type="button"
                  className="btn-close"
                  onClick={() => onClose()}
                  aria-label="Close"
                ></button> */}
              </div>
            )}
            {children}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              {t('editModal.cancel')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onSave}
              disabled={isSaving}
            >
              {isSaving ? t('editModal.saving') : t('editModal.saveChanges')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditModal;
